export default __webpack_public_path__ + "static/soehne-web-fett-kursiv-c979b20bcd41b0959b67aaed1cba7b90.woff2";